import * as React from 'react';
import { Control } from './control';
import { ControlHelper, EComponentTypes, EConfirmationOperationType, EControlTypes, EModalType, IComponent, IControl, IControlLayoutPanel, OutputsHelper, clone, getLayoutPanelFromService } from '../../helpers';
import { COMPONENT_MENU, NON_REPEATABLE_CONTROL_TYPES } from '../../constants';
import { Button, ButtonType, ContextualMenu, DirectionalHint, IContextualMenuItem } from 'office-ui-fabric-react';
import Collapsible from 'react-collapsible';
import store from '../../store/store';
import LoopConfigContainer from '../../containers/loop-config';
import CascadeContainer from '../../containers/cascade';
import types from '../../store/types';
import ControlConfigContainer from '../../containers/control-config';

interface IProps {
    controls: IControl[];
    layoutPanels: IControlLayoutPanel[];
    componentId: string;
    inLoop: boolean;
    previousOutputBlocks: any
    toggleDialog: (componentId: string, controlIndex: number, previousOutputBlocks?: any, layoutPanelIndex?: number) => void;
    toggleLoopingDialog: (componentId: string) => void;
    component: IComponent;
    deleteControl?: () => void;
    deleteLayoutPanel?: (componentId: string, layoutPanelIndex?: number) => void;
    dismissErrorMessage?: () => void;
    getMenu?: (branchIndex?: number) => IContextualMenuItem[];
    toggleShowMenu?: (showMenuVal: boolean, showMenuIndexVal: number) => void;
    toggleMenu?: (componentId: string) => void;
    showMenu?: boolean;
    // toggleSidebar?: (componentId: string) => void;
    controlIndex?: number;
    toggleSidebar: (component: IComponent, keepOpen?: boolean, previousOutputBlocks?: any, isLayoutPanel?: boolean, layoutPanelIndex?: number) => void;
    addNewLayoutPanel?: (componentId: string) => void;

};

export class ControlList extends React.Component<IProps, any> {

    constructor(props: any) {
        super(props);
        this.state = {
            showBlockContent: true,
            showBlockTabs: false,
            showNewBlock: false,
            currentControlIndex: -1,
            isBlockDeleted: false,
            currentLayoutPanelIndex: null,
            showMenu: false,
            showMenuIndex: null,

        };
        this.changeShowBlockContent = this.changeShowBlockContent.bind(this);
        this.changeShowBlockTabs = this.changeShowBlockTabs.bind(this);
        this.changeShowNewBlock = this.changeShowNewBlock.bind(this);
        this.changeCurrentControlIndex = this.changeCurrentControlIndex.bind(this);
        this.changeIsBlockDeleted = this.changeIsBlockDeleted.bind(this);
        this.changeCurrentLayoutPanelIndex = this.changeCurrentLayoutPanelIndex.bind(this);
        this.changeShowMenu = this.changeShowMenu.bind(this);
        this.changeEditIndex = this.changeEditIndex.bind(this);


    }

    // Toggle hamburger menu and set index to the active decision branch's index
    changeShowMenu(showMenuVal: boolean, showMenuIndexVal: number) {
        this.setState({
            showMenu: !showMenuVal,
            showMenuIndex: showMenuIndexVal
        });
    }
    changeEditIndex(val: number) {
        if (val === null) {

        }
        this.setState({
            editIndex: val
        });
    }


    deleteControl = (controlId: string) => {
        let { toggleDialog, componentId } = this.props;

        let state = store.getState().modalState.controlConfig;

        let deletedOutputs = state.control.OutputValues && state.control.OutputValues.map(x => x.Id);
        let isDeletedOutputUsed = false;
        let outputsInUse = store.getState().outputsState.outputsInUse;
        Object.keys(outputsInUse).forEach(element => {
            outputsInUse[element].filter(x => deletedOutputs && deletedOutputs.includes(x)).length ? isDeletedOutputUsed = true : null;
        });
        let confirmationMessage = 'Are you sure you want to delete this control from the section?';

        if (deletedOutputs && deletedOutputs.length && isDeletedOutputUsed) {
            confirmationMessage = 'One or more outputs from this control are used as value in the journey. Saving the changes will remove the values in those places. Are you sure you want to proceed?';

            // Commented out because it only deletes from control list and not layout panel list. Note that we are maintaining two lists for controls i.e. controls list (to support previous version) and layout panel list (new feature).
            // store.dispatch({
            //     type: types.TOGGLE_CONFIRMATION_DIALOG,
            //     operationType: EConfirmationOperationType.CascadeControlOutputValues,
            //     title: 'Confirm Deletion',
            //     message: 'One or more deleted outputs are used as value in the journey. Saving the changes will remove the values in those places. Are you sure you want to proceed?',
            //     isOpen: true,
            //     deletedOutputs: deletedOutputs,
            //     componentId: state.componentId,
            //     action: state.control,
            //     // componentId: state.control.ComponentId,
            //     controlIndex: state.controlIndex,
            //     outputs: state.control.OutputValues
            // })
        }
        // else {

        if (state.control.ControlId.length) {
            store.dispatch({
                type: types.TOGGLE_CONFIRMATION_DIALOG,
                operationType: EConfirmationOperationType.DeleteControl,
                title: 'Confirm Deletion',
                message: confirmationMessage,
                isOpen: true,
                okButtonLabel: 'Delete',
                cancelButtonLabel: 'Cancel',
                componentId: state.control.ComponentId,
                controlIndex: state.controlIndex,
                layoutPanelIndex: state.layoutPanelIndex,
                outputs: state.control.OutputValues,
                deletedOutputs: deletedOutputs,
                controlId: controlId
            });

            store.dispatch({ type: types.TOGGLE_DIALOG, openModal: EModalType.None });
        }
        // }

        store.dispatch({ type: types.TOGGLE_DIALOG, openModal: EModalType.None });

        // this.changeIsBlockDeleted(true);
        this.changeCurrentControlIndex(-1);
        toggleDialog(componentId, -1);
    }

    deleteLayoutPanel = (layoutPanelIndex: number) => {
        let { toggleDialog, componentId, layoutPanels } = this.props;

        let state = store.getState().modalState.controlConfig;

        // let deletedOutputs = state.control.OutputValues && state.control.OutputValues.map(x => x.Id);
        let outputs = store.getState().processState.components[componentId].ControlBlock.LayoutPanels[layoutPanelIndex].Controls.map(x => x.OutputValues).flat().filter(x => x !== null);
        let allOutputValues = store.getState().processState.components[componentId].ControlBlock.LayoutPanels[layoutPanelIndex].Controls.map(x => x.OutputValues).flat().filter(x => x !== null);
        let deletedOutputs = allOutputValues.length ?
            allOutputValues.map(x => x.Id) :
            null;
        let isDeletedOutputUsed = false;
        let outputsInUse = store.getState().outputsState.outputsInUse;
        Object.keys(outputsInUse).forEach(element => {
            outputsInUse[element].filter(x => deletedOutputs && deletedOutputs.includes(x)).length ? isDeletedOutputUsed = true : null;
        });
        let confirmationMessage = 'Are you sure you want to delete this layout panel from the section?';

        if (deletedOutputs && deletedOutputs.length && isDeletedOutputUsed) {
            confirmationMessage = 'One or more control outputs from this layout panel are used as value in the journey. Saving the changes will remove the values in those places. Are you sure you want to proceed?';
        }
        if (layoutPanels && layoutPanels.length >= layoutPanelIndex) {
            store.dispatch({
                type: types.TOGGLE_CONFIRMATION_DIALOG,
                operationType: EConfirmationOperationType.DeleteLayoutPanel,
                title: 'Confirm Deletion',
                message: confirmationMessage,
                isOpen: true,
                okButtonLabel: 'Delete',
                cancelButtonLabel: 'Cancel',
                componentId: componentId,
                // controlIndex: state.controlIndex,
                outputs: outputs,
                deletedOutputs: deletedOutputs,
                layoutPanelIndex: layoutPanelIndex,
            });

            store.dispatch({ type: types.TOGGLE_DIALOG, openModal: EModalType.None });
        }
        // }

        store.dispatch({ type: types.TOGGLE_DIALOG, openModal: EModalType.None });

        // this.changeIsBlockDeleted(true);
        this.changeCurrentControlIndex(-1);
        toggleDialog(componentId, -1);
    }

    changeShowBlockContent(val) {
        this.setState({
            showBlockContent: val
        });

    }

    changeShowBlockTabs(val) {
        this.setState({
            showBlockTabs: val
        });

    }
    changeShowNewBlock(val, updateControl?, layoutPanelIndex?) {
        let { controls, toggleDialog, componentId, previousOutputBlocks, dismissErrorMessage } = this.props;

        !val ? dismissErrorMessage() : null;

        if (updateControl) {
            (layoutPanelIndex !== null && layoutPanelIndex !== undefined) ?
                toggleDialog(componentId, controls.length - 1, previousOutputBlocks, layoutPanelIndex)
                :
                toggleDialog(componentId, controls.length - 1, previousOutputBlocks)
            // store.getState().modalState.controlConfig.controlIndex = controls.length - 1;
            this.changeCurrentControlIndex(controls.length - 1);
        }

        this.setState({
            showNewBlock: val
        });
    }
    deepDelete(obj, propToDelete) {
        for (const key in obj) {
            if (obj.hasOwnProperty(key)) {
                if (typeof obj[key] === 'object' && obj[key] !== null) {
                    this.deepDelete(obj[key], propToDelete);
                } else if (key === propToDelete) {
                    delete obj[key];
                }
            }
        }
        return obj;
    }

    toggleControlList(controlIndex: number, newControlIndex: number, layoutPanelIndex?: number) {
        let {
            component, toggleDialog, previousOutputBlocks
        } = this.props;

        let componentId;
        let controlId;
        let modalStateComponent;
        let processStateComponent;
        let componentModal;
        let componentTypeToCheck;


        // get the component to check from openmodal
        const openModal = store.getState().modalState.modal.openModal;
        switch (openModal) {
            case EModalType.ControlConfig:
                componentTypeToCheck = EComponentTypes.block;
                break;
            default:
                break;

        }
        // do the check

        // approprate confirmation dialog

        switch (componentTypeToCheck) {
            case EComponentTypes.block:
                componentId = store.getState().modalState.controlConfig.componentId;
                controlId = store.getState().modalState.controlConfig.control.ControlId;
                modalStateComponent = store.getState().modalState.controlConfig.control;
                processStateComponent = (componentId && controlId) ? store.getState().processState.components[componentId].ControlBlock.Controls.filter(x => x.ControlId === controlId)[0] : null;
                componentModal = EModalType.ControlConfig;
                break;
            default:
                break;
        }

        // if ((store.getState().modalState.actionConfig.componentId === component.Id &&
        //     store.getState().modalState.modal.openModal === EModalType.ActionConfig)) {
        if (openModal != EModalType.None || controlId) {
            if (componentId && modalStateComponent && processStateComponent) {

                const modalComponent = this.deepDelete(modalStateComponent, 'IsInvisible');
                const processComponent = this.deepDelete(processStateComponent, 'IsInvisible');
                if (JSON.stringify(modalComponent) !== JSON.stringify(processComponent)) {
                    store.dispatch({
                        type: types.TOGGLE_CONFIRMATION_DIALOG,
                        operationType: EConfirmationOperationType.ToggleComponent,
                        title: 'Unsaved Changes',
                        message: 'You have some unsaved changes. Please save to prevent any lost changes or cancel to discard them.',
                        isOpen: true,
                        okButtonLabel: 'Ok',
                        isCancelButtonHidden: true,
                        modalStateComponentId: modalStateComponent.Id,
                        componentId: component.Id,
                        openModal: openModal,
                        componentModal: componentModal,
                        previousOutputBlocks: previousOutputBlocks
                    })
                    return;
                }
            }
        }

        (layoutPanelIndex !== null && layoutPanelIndex !== undefined) ?
            toggleDialog(componentId, newControlIndex, null, layoutPanelIndex)
            :
            toggleDialog(componentId, newControlIndex);

        if (controlIndex != null && this.state.currentControlIndex === newControlIndex) {
            this.changeCurrentControlIndex(-1);
        } else {
            this.changeCurrentControlIndex(newControlIndex)
        }


    }


    changeCurrentLayoutPanelIndex(val) {

        this.setState({
            currentLayoutPanelIndex: val
        });
    }

    changeCurrentControlIndex(val) {
        let { controls } = this.props;
        this.setState({
            currentControlIndex: val
        });

        // switch (component.ComponentType.ComponentTypeId) {
        //     case EComponentTypes.block:
        //         // control
        //         let {
        //             toggleDialog } = this.props;

        //         if (store.getState().modalState.controlConfig.componentId === component.Id &&
        //             store.getState().modalState.modal.openModal === EModalType.ControlConfig) {
        //             store.getState().modalState.controlConfig.componentId = '';
        //         }
        //         else {
        //             toggleDialog(component.Id, null, previousOutputBlocks);
        //         }
        //         break;

        //     default:
        //         break;

        // }

        if (val === -1) {
            store.dispatch({ type: types.UPDATE_CONTROL_DIALOG });
        } else {
            
            switch (controls[val].ControlType.NameType) {
                case "Get View":
                    const getViewEntityName = controls[val].Properties.filter(x => x.Name === "Entity Name")[0].Value;
                    if (getViewEntityName) {
                        ControlHelper.loadEntityFields(getViewEntityName, controls[val].ComponentId);
                        ControlHelper.changeEntityView("Entity Name", getViewEntityName, controls[val], store.getState().propertyFilterState);
                        ControlHelper.changeEntityForm("Entity Name", getViewEntityName, controls[val], store.getState().propertyFilterState);
                    } else {
                        // reset all the entity name related variables
                        ControlHelper.resetAllEntityStateVariables();
                    }
                    break;

                case "Create Form":
                    const createFormEntityName = controls[val].Properties.filter(x => x.Name === "Entity Name")[0].Value;
                    if (createFormEntityName) {
                        ControlHelper.loadEntityFields(createFormEntityName, controls[val].ComponentId);
                        ControlHelper.changeEntityForm("Entity Name", createFormEntityName, controls[val], store.getState().propertyFilterState);
                    } else {
                        // reset all the entity name related variables
                        ControlHelper.resetAllEntityStateVariables();
                    }
                    break;

            }
        }

    }

    changeIsBlockDeleted(val) {
        this.setState({
            isBlockDeleted: val
        });

    }

    instanceOfA(object: any): object is IControl {
        return 'ControlId' in object;
    }


    componentDidMount(): void {
        let { controls, layoutPanels, componentId } = this.props;

        // for older version, where there is no layout panel in the block, automatically create one and place all the controls inside it.
        if (!layoutPanels.length) {
            getLayoutPanelFromService().then((layoutPanels: any) => {
                layoutPanels[0].Controls = controls
                ControlHelper.createLayoutPanelsFromControls(componentId, layoutPanels);
            });
        }
    }


    getMenu = (layoutPanelIndex: number): IContextualMenuItem[] => {

        let menu: IContextualMenuItem[] = clone(COMPONENT_MENU);
        let { component, toggleSidebar } = this.props;

        let isSubmission = component.ComponentType.ComponentTypeId === EComponentTypes.submission;

        if (component.ComponentType.ComponentTypeId === EComponentTypes.summary) {
            menu[0].disabled = true;
        } else {
            menu[0].onClick = () => {
                console.log('layout contextual menu',);
                const isLayoutPanel = true;
                this.props.toggleSidebar(component, false, null, isLayoutPanel, layoutPanelIndex)
            }
        }
        menu[1].onClick = () => {
            this.deleteLayoutPanel(layoutPanelIndex);
        };
        return menu;

    }

    public render() {
        let { controls, layoutPanels, toggleDialog, toggleShowMenu, componentId, inLoop,
            previousOutputBlocks, component, controlIndex, dismissErrorMessage,
            addNewLayoutPanel, toggleMenu, showMenu } = this.props;
        const controlType = controls && controls.length ? this.instanceOfA(controls[0]) : null;

        let items: JSX.Element[];
        // if layoutPanels exists, then show layout panels. else show the old control block
        if (layoutPanels && layoutPanels.length) {
            items = layoutPanels.map((l, lIndex) => {
                let contextMenu: JSX.Element = this.state.showMenu && this.state.showMenuIndex === lIndex &&
                    <ContextualMenu target={'.more-' + component.Id + '-layout-panel-' + lIndex}
                        shouldFocusOnMount={false}
                        onDismiss={() => {
                            this.changeShowMenu(this.state.showMenu, lIndex);
                            this.changeCurrentLayoutPanelIndex(null);
                            toggleShowMenu(true, 0)
                        }}
                        directionalHint={DirectionalHint.bottomRightEdge}
                        items={this.getMenu(lIndex)}
                        isBeakVisible={true}
                        beakWidth={15} />;
                let layoutPanelWidth = eval(layoutPanels[lIndex].Properties.filter(x => x.Name.toLowerCase() === 'width')[0].Value) * 12;

                let layoutPanleControls =
                    l.Controls && l.Controls.length ?
                        l.Controls.map((c, cIndex) => {
                            return <div key={'control_' + componentId + '_' + lIndex + '_' + cIndex} className="block-component" >
                                <Collapsible
                                    overflowWhenOpen='visible'
                                    handleTriggerClick={(event) => {
                                        this.changeShowNewBlock(false);
                                        this.toggleControlList(controlIndex, cIndex, lIndex);
                                    }}
                                    className="Collapsible__trigger is-disabled"
                                    disabled={this.state.showNewBlock}
                                    open={this.state.currentControlIndex === cIndex}
                                    onClosing={dismissErrorMessage}
                                    trigger={
                                        <Control key={'ct_' + '_' + cIndex}
                                            control={c}
                                            componentId={componentId}
                                            controlIndex={cIndex}
                                            layoutPanelIndex={lIndex}
                                            toggleDialog={toggleDialog}
                                            showBlockContent={this.state.showBlockContent}
                                            changeShowBlockContent={this.changeShowBlockContent}
                                            component={component}
                                            deleteControl={this.deleteControl} />
                                    } >
                                    {
                                        store.getState().modalState.controlConfig.controlIndex === cIndex &&
                                            store.getState().modalState.controlConfig.layoutPanelIndex === lIndex ?
                                            <CascadeContainer
                                                showBlockContent={!this.state.showBlockContent}
                                                showBlockTabs={true}
                                                changeShowBlockContent={this.changeShowBlockContent}
                                                changeCurrentControlIndex={this.changeCurrentControlIndex} />
                                            : null}
                                </Collapsible>
                            </div >
                        })
                        :
                        <div
                            className="empty-block-layout-panel"
                            onDrop={(e) => ControlHelper.drop(e, 0, lIndex)}
                            onDragOver={ControlHelper.allowDrop}                        >
                        </div>

                return <div className={"control-list-item col-xs-12 col-sm-" + layoutPanelWidth}>
                    <div className={"block-layout-panel"}>
                        <div className="component-head custom-bg-Block">
                            <div className="">
                                <span className="component-name">
                                    {l.Name}
                                </span>
                                <div className="actions">
                                    <Button buttonType={ButtonType.icon}
                                        icon='More'
                                        title='More'
                                        className={'action more-' + component.Id + '-layout-panel-' + lIndex}
                                        onClick={(e) => {
                                            this.changeCurrentLayoutPanelIndex(lIndex);
                                            this.changeShowMenu(this.state.showMenu, lIndex);
                                            e.stopPropagation();
                                            return true;
                                        }} />
                                    {contextMenu}
                                </div>
                            </div>
                        </div>
                        {layoutPanleControls}
                    </div>
                </div>
            });
        } else {

            items = controls.map((c, i) => {
                return <div key={'control_' + componentId + '_' + i} className="block-component">
                    <Collapsible
                        overflowWhenOpen='visible'
                        handleTriggerClick={(event) => {
                            this.changeShowNewBlock(false);
                            this.toggleControlList(controlIndex, i);
                            // if (controlIndex != null && this.state.currentControlIndex === i) {
                            //     this.changeCurrentControlIndex(-1);
                            // } else {
                            //     this.changeCurrentControlIndex(i)
                            // }
                        }}
                        className="Collapsible__trigger is-disabled"
                        disabled={this.state.showNewBlock}
                        open={this.state.currentControlIndex === i}
                        onClosing={dismissErrorMessage}
                        trigger={
                            <Control key={'ct_' + '_' + i}
                                control={c}
                                componentId={componentId}
                                controlIndex={i}
                                toggleDialog={toggleDialog}
                                showBlockContent={this.state.showBlockContent}
                                changeShowBlockContent={this.changeShowBlockContent}
                                component={component}
                                deleteControl={this.deleteControl} />
                        } >
                        {store.getState().modalState.controlConfig.controlIndex === i ?
                            <CascadeContainer
                                showBlockContent={!this.state.showBlockContent}
                                showBlockTabs={true}
                                changeShowBlockContent={this.changeShowBlockContent}
                                changeCurrentControlIndex={this.changeCurrentControlIndex} />
                            : null}
                    </Collapsible>
                </div >
            });
        }

        let containsNonRepeatableControls = controls.some((c) => NON_REPEATABLE_CONTROL_TYPES.indexOf(c.ControlType.NameType) > - 1);
        let shouldRender = store.getState().modalState.actionConfig.componentId ? componentId === store.getState().modalState.actionConfig.componentId : false;

        return (<div className="block-component-container">

            {/* Start of all block components and newly created (in the end) */}
            <div className="row control-list ovh">

                {items}

                {
                    this.state.showNewBlock ?
                        <div className="new-block-component-inner component-inner">
                            <Collapsible
                                overflowWhenOpen="visible"
                                open={this.state.currentControlIndex === null}
                                onOpening={() => {
                                    // reset all the entity name related variables
                                }}
                                trigger={
                                    <div className="component-head decision-head new-config-head">
                                        <span className="component-name">
                                            {/* {componentName} */}
                                            New Block Component

                                        </span>
                                        <div className="actions">
                                        </div>

                                    </div>
                                } >

                                <CascadeContainer showBlockContent={this.state.showBlockContent} showBlockTabs={true}
                                    changeShowBlockContent={this.changeShowBlockContent}
                                    changeShowBlockTabs={this.changeShowBlockTabs}
                                    changeShowNewBlock={this.changeShowNewBlock}
                                    controls={controls}
                                    isNewBlock={true} />
                            </Collapsible>
                        </div>
                        : null
                }

            </div>
            {/* End of all block components and newly created (in the end) */}

            {/* Start of Add button */}
            {/* <Button
                className="block-component-btn-primary"
                buttonType={ButtonType.primary}
                onClick={() => {
                    this.setState({
                        showBlockTabs: false,
                        currentControlIndex: null
                    });
                    store.getState().modalState.controlConfig.componentId = '';
                    toggleDialog(componentId, null, previousOutputBlocks);
                    this.changeShowBlockContent(false);
                    this.changeShowNewBlock(false);
                }}>
                <i className="ms-Icon ms-Icon--Add" aria-hidden="true"></i> Add
            </Button> */}

            <Button
                buttonType={ButtonType.icon}
                icon='Add'
                title='Add'
                className={'action add-search badge-circle '
                    + ((!this.state.showBlockContent && store.getState().modalState.controlConfig.controlIndex === null && !this.state.showBlockTabs) ? 'transform-icon' : '')}
                // tabIndex={branches.length * 5 + 1}
                onClick={() => {
                    this.setState({
                        showBlockTabs: false,
                        currentControlIndex: null
                    });
                    store.getState().modalState.controlConfig.componentId = '';
                    toggleDialog(componentId, null, previousOutputBlocks, layoutPanels.length - 1);
                    this.changeShowBlockContent(!this.state.showBlockContent);
                    this.changeShowNewBlock(false);
                }}
            />

            {/* End of Add button */}

            {/* Start of block component options */}
            {!this.state.showBlockContent && store.getState().modalState.controlConfig.controlIndex === null && !this.state.showBlockTabs ?
                <div className="control-option-container">
                    <CascadeContainer showBlockContent={this.state.showBlockContent}
                        showBlockTabs={this.state.showBlockTabs}
                        changeShowBlockContent={this.changeShowBlockContent}
                        changeShowBlockTabs={this.changeShowBlockTabs}
                        changeShowNewBlock={this.changeShowNewBlock}
                        addNewLayoutPanel={addNewLayoutPanel}
                        componentId={componentId}
                    />
                </div>
                : null}
            {/* End of block component options */}

            {/* <div className="new-layout-block">
                <Button
                    className="btn-new-layout"
                    tabIndex={1100}
                    buttonType={ButtonType.primary}
                    onClick={() => {
                        addNewLayoutPanel(componentId)
                    }} >
                    New Layout Panel
                </Button>
            </div> */}

        </div >);

    };

};


// WEBPACK FOOTER //
// ./source/ts/components/controls/control-list.tsx